import classNames from 'classnames';
import {generateMainSitePath} from 'epic-fortnite-react/utils/FortniteUtils';
import PropTypes from 'prop-types';
import {generateRouteHref} from 'epic-fortnite-react';
import React from 'react';
import root from 'window-or-global';
import {withRouter} from 'react-router';

const getLinkForCountry = (platform, country, download, location) => {
  const downloadLinks = download[platform];
  let downloadLink;
  let rowLink = generateRouteHref('/download', location);
  let foundLink = false;
  for (let i = 0; i < downloadLinks.length; i++) {
    const link = downloadLinks[i];
    if (link.country.indexOf(country) >= 0) {
      foundLink = true;
      downloadLink = link.link;
    }
    if (link.country === 'ROW') {
      rowLink = link.link;
    }
  }
  return foundLink ? downloadLink : rowLink;
};

class DownloadButton extends React.Component {
  static propTypes = {
    appConfigStore: PropTypes.object.isRequired,
    mobileStore: PropTypes.object.isRequired,
    os: PropTypes.string,
    messages: PropTypes.object,
    mobile: PropTypes.bool,
    download: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    disableText: PropTypes.bool,
    countryCode: PropTypes.string,
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    // Set to true to auto redirect to android, psn, switch download pages when viewed with those platforms.
    enableAutoRedirect: PropTypes.bool,
  };

  // signIn function removed as asking the user to login to download Fortnite is
  // no longer required. The comment below was referencing this login functionality

  // TODO: Temporary fix that needs review when config solution is put in place
  // for reference: https://jira.it.epicgames.com/browse/EGS-42070
  // LoginActions.requestRegister({returnPath: generateMainSitePath(url)});
  //     LoginActions.requestRegister({returnPath: url});
  //   }
  // };

  extLinkPSN = () => {
    const {
      appConfigStore: {platformDownloadLinks},
      countryCode,
    } = this.props;
    const extLink = getLinkForCountry(
      'psn',
      countryCode,
      platformDownloadLinks,
      this.props.location
    );
    root.open(extLink);
  };

  extLinkXBox = () => {
    const {
      appConfigStore: {platformDownloadLinks},
      countryCode,
    } = this.props;
    const extLink = getLinkForCountry(
      'xbl',
      countryCode,
      platformDownloadLinks,
      this.props.location
    );
    root.open(extLink);
  };

  extLinkSwitch = () => {
    const {
      appConfigStore: {platformDownloadLinks},
      countryCode,
    } = this.props;
    const extLink = getLinkForCountry(
      'nintendo',
      countryCode,
      platformDownloadLinks,
      this.props.location
    );
    root.open(extLink);
  };

  intLinkMobileAndroid = () => {
    const goAndroid = generateRouteHref('/mobile/android', this.props.location);
    root.location.href = goAndroid;
  };

  intLinkMac = () => {
    const {
      appConfigStore: {macDownloadUrl},
      location,
    } = this.props;
    const intLink = getLinkForCountry('mac', macDownloadUrl, undefined, location);
    root.open(intLink);
  };

  intLinkPC = () => {
    const {
      appConfigStore: {pcDownloadUrl},
    } = this.props;
    const intLink = getLinkForCountry('windows', pcDownloadUrl);
    root.open(intLink);
  };

  componentDidMount() {
    // Auto download the game on a supported platform.
    const {
      os,
      appConfigStore: {pcDownloadUrl, macDownloadUrl},
      download,
      enableAutoRedirect,
    } = this.props;
    const androidDownloadUrl = generateRouteHref('/mobile/android', this.props.location);
    let downloadUrl = '';
    switch (os) {
      case 'windows':
        if (!download) {
          return;
        }
        downloadUrl = pcDownloadUrl;
        break;
      case 'mac':
        if (!download) {
          return;
        }
        downloadUrl = macDownloadUrl;
        break;
      case 'android':
        if (!enableAutoRedirect) {
          return;
        }
        downloadUrl = generateMainSitePath(androidDownloadUrl);
        break;
      case 'ios':
        if (!enableAutoRedirect) {
          return;
        }
        break;
      case 'psn':
        if (!enableAutoRedirect) {
          return;
        }
        setTimeout(this.extLinkPSN, 2000);
        break;
      case 'nintendo':
        if (!enableAutoRedirect) {
          return;
        }
        setTimeout(this.extLinkSwitch, 2000);
        break;
      case 'xbl':
        if (!enableAutoRedirect) {
          return;
        }
        setTimeout(this.extLinkXBox, 2000);
        break;
      default:
    }
    if (downloadUrl) {
      setTimeout(() => {
        root.location = downloadUrl;
      }, 2000);
    }
  }

  render() {
    const {
      messages,
      os,
      appConfigStore: {pcDownloadUrl, macDownloadUrl},
      mobile,
      disableText,
    } = this.props;
    const androidDownloadUrl = generateRouteHref('/mobile/android', this.props.location);
    const classes = classNames('button', disableText ? 'notext' : '');

    switch (os) {
      case 'mac':
        if (!mobile) {
          return (
            <a title={messages['epic.common.mac']} className={classes} href={macDownloadUrl}>
              <i className="icon-mac-os" />
              {disableText ? '' : <span>{messages['epic.common.mac']}</span>}
            </a>
          );
        }
        return (
          <div
            role="presentation"
            title={messages['epic.common.mac']}
            className={classes}
            onClick={() => this.intLinkMac(macDownloadUrl)}>
            <i className="icon-mac-os" />
            {disableText ? '' : <span>{messages['epic.common.mac']}</span>}
          </div>
        );
      case 'android':
        return (
          <div
            role="presentation"
            title={messages['epic.common.android']}
            className={classes}
            onClick={() => this.intLinkMobileAndroid(androidDownloadUrl)}>
            <i className="icon-android" />
            {disableText ? '' : <span>{messages['epic.common.android']}</span>}
          </div>
        );
      case 'psn':
        return (
          <div
            role="presentation"
            title={messages['epic.common.psn']}
            className={classes}
            onClick={this.extLinkPSN}>
            <i className="icon-ps4" />
            {disableText ? '' : <span>{messages['epic.common.psn']}</span>}
          </div>
        );
      case 'nintendo':
        return (
          <div
            role="presentation"
            title={messages['epic.common.nintendo']}
            className={classes}
            onClick={this.extLinkSwitch}>
            <i className="icon-nintendo" />
            {disableText ? '' : <span>{messages['epic.common.nintendo']}</span>}
          </div>
        );
      case 'xbl':
        return (
          <div
            role="presentation"
            title={messages['epic.common.xbl']}
            className={classes}
            onClick={this.extLinkXBox}>
            <i className="icon-xbox" />
            {disableText ? '' : <span>{messages['epic.common.xbl']}</span>}
          </div>
        );
      case 'windows':
      default:
        if (!mobile) {
          return (
            <a title={messages['epic.common.windows']} className={classes} href={pcDownloadUrl}>
              <i className="icon-pc" />
              {disableText ? '' : <span>{messages['epic.common.windows']}</span>}
            </a>
          );
        }
        return (
          <div
            role="presentation"
            title={messages['epic.common.windows']}
            className={classes}
            onClick={() => this.intLinkPC(pcDownloadUrl)}>
            <i className="icon-pc" />
            {disableText ? '' : <span>{messages['epic.common.windows']}</span>}
          </div>
        );
    }
  }
}

export default withRouter(DownloadButton);
